export default __webpack_public_path__ + "static/media/profile-cion.d8ea7bca.svg";